import React, { FunctionComponent, memo, useEffect } from 'react';
import { useDataStore, useUserStore } from '../../../zustand';
import { IComponentType, IFaceLandmark, IFaceLandmarkGroup, ISceneComp } from '@r3f-component-data-structure';
import { generateHocComponents } from '../../Scene/ArComponents';

const OriginContent: FunctionComponent<{ sceneId: string }> = ({ sceneId }) => {
	const componentsById = useDataStore(({componentsById}) => componentsById);
	const rootId = useDataStore(({rootId}) => rootId!);
	const isFaceTrackingVisible = useUserStore(({isFaceTrackingVisible}) => isFaceTrackingVisible);

	if (!componentsById || !rootId) return null;

	const originTrackedLandmarkGroupId = (componentsById[sceneId] as ISceneComp).children
		.filter((id) => componentsById[id].type === IComponentType.FaceLandmarkGroup && (componentsById[id] as IFaceLandmarkGroup).landmark == IFaceLandmark.origin)[0];

	if (!originTrackedLandmarkGroupId) return null;

	// This scene contains an origin tracked group - generate the child components
	const originTrackedComponentIds = (componentsById[originTrackedLandmarkGroupId] as IFaceLandmarkGroup).children;
	const originChildren = generateHocComponents(originTrackedComponentIds, sceneId, componentsById, true);

	return <group scale={2} name={'origin-group'} visible={isFaceTrackingVisible}>{originChildren}</group>;
};

OriginContent.displayName = 'OriginContent';
export default memo(OriginContent);
